import React from "react";
import "./HeroSection.css";
import lefthand from "../../assets/HeroSection/lefthand.svg";
import righthand from "../../assets/HeroSection/righthand.svg";
import star from "../../assets/HeroSection/star.png";

const HeroSection = () => {
  return (
    <section className="heroSection">
      <div>
        <div className="image-container ">
          <div className="Hands">
            <img src={lefthand} alt="left-Hand" className="lefthand" />
          </div>
          <img src={star} alt="star" className="star" />
          <div className="Hands">
            <img src={righthand} alt="right-Hand" className="righthand" />
          </div>
        </div>
        <div className="creditsContainer">
          <p>
            <a
              href="https://www.behance.net/gallery/208990039/Holding-onto-the-past?"
              target="_blank"
              rel="noreferrer"
              className="artCredits anchorlink"
            >
              illustration by anu preetha
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
